import angular from 'angular';

class invitationDetailsCtrl {
    /* @ngInject */
    constructor($state, $translate, KISS_SELLER) {
        this.$state = $state;
        this.$translate = $translate;
        this.KISS_SELLER = KISS_SELLER;
    }

    getEntityStatusLabel() {
        if (this.entity && this.entity.status) {
            return this.$translate.instant('kiss_seller.status.' + angular.lowercase(this.entity.status));
        }
        return '';
    }

    isEntityCreated() {
        if (this.entity) {
            return this.entity.status && this.entity.status === this.KISS_SELLER.seller.status[0].value;
        }
    }

    isEntityNotified() {
        if (this.entity) {
            return this.entity.status && this.entity.status === this.KISS_SELLER.seller.status[1].value;
        }
    }

    isEntityActive() {
        if (this.entity) {
            return this.entity.status && this.entity.status === this.KISS_SELLER.seller.status[2].value;
        }
    }

    isEntityInactive() {
        if (this.entity) {
            return this.entity.status && this.entity.status === this.KISS_SELLER.seller.status[3].value;
        }
    }

    back() {
        if (this.type === 'seller') {
            this.$state.go('app.principal.consult.listsellers');
        } else {
            this.$state.go('app.principal.consult.listbuyers');
        }
    }
}

angular.module('app.principal').component('invitationDetails', {
    templateUrl: require('./invitation-details.html'),
    controller: invitationDetailsCtrl,
    bindings: {
        entity: '<',
        invitation: '<',
        type: '<',
    },
});
